<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/user/user-list' }">账号管理</el-breadcrumb-item>
          <el-breadcrumb-item >修改账号</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="equip-add">
      <dv-border-box-12>
        <div style="padding: 6px 6px 8px 6px;">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">修改账号信息</div>
            </div>
          </div>
          <el-form
            :model="form"
              label-width="100px"
              class="add-form"
              :rules="rules"
              ref="form">
              <!-- <el-form-item label="所属分组" prop="group">
                <el-select v-model="form.group" placeholder="点击选择分组"  @change="groupChange($event)" style="width: 50%;">
                  <el-option
                    v-for="item in groups"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="所在分组" prop="group">
                <el-input id="group" v-model="form.group" placeholder="所在分组" style="width: 50%;float: left;" readonly>
                </el-input>
                <el-button @click="showGroups" size='mini' style="margin-left: 10px;">选择分组</el-button>
                <!-- <el-select v-model="form.group" placeholder="点击选择分组"  @change="groupChange($event)" style="width: 50%;">
                  <el-option
                    v-for="item in groups"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select> -->
              </el-form-item>
              <el-form-item label="账号名" prop="username" >
                <el-input id="username" v-model="form.username"  placeholder="英文数字组合" style="width: 50%;" :readonly="true"></el-input>
              </el-form-item>
              <el-form-item label="登录密码" prop="password" >
                <el-input id="password" v-model="form.password" placeholder="请输入登录密码" clearable style="width: 50%;"></el-input>
              </el-form-item>
              <el-form-item label="用户姓名" prop="nickname">
                <el-input  id="nickname" v-model="form.nickname" placeholder="请输入真实姓名" clearable style="width: 50%;float: left;"></el-input>
                <el-button class="warning-handle" @click="resetForm('nickname')" size='mini'>重置</el-button>
              </el-form-item>
              <el-form-item label="手机号" prop="phone" >
                <el-input id="phone" v-model="form.phone" placeholder="请输入手机号" clearable style="width: 50%;float: left;" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                <el-button class="warning-handle" @click="resetForm('phone')" size='mini'>重置</el-button>
              </el-form-item>
              <el-form-item style="margin-top: 40px;">
                <el-button class="action-button" type="primary"  @click="submitForm('form')">立即保存</el-button>
                <!-- <el-button class="action-button" @click="resetForm('form')">重置</el-button> -->
              </el-form-item>
            </el-form>
        </div>
      </dv-border-box-12>
    </div>

    <template>
    <!-- 分组列表 -->
      <el-dialog :visible.sync="showMoreGroups" title="分组列表">
        <el-table
          :data="groups"
          border
          style="width: 100%;"
          :max-height="400"
          @cell-click="chooseOneGroup"
          >
          <el-table-column
            type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            prop="code"
            label="分组编码">
          </el-table-column>
          <el-table-column
            prop="name"
            label="分组名称">
          </el-table-column>
        </el-table>
      </el-dialog>

    </template>
  </div>
</template>

<script>

  export default {
    props: {
    },
    data() {
      return {
        groups:[],
        form: {
          group: '',
          groupCode:'',
          userId:'',
          username: '',//账号名
          password:'',
          nickname:'',//真实姓名
          phone: '',
        },
        showMoreGroups:false,
        rules: {
          // group: [{ required: true, message: '请选择分组', trigger: 'blur' }],
          // username: [{ required: true, message: '请输入账户', trigger: 'blur' }],
          // password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
          phone: [{min: 11,max:11,message:'请输入11位手机号'}]
        },

      }
    },
    mounted() {
      // this.getGroupList()
      this.getAccountDetail()
      this.getGroupList()
    },
    created() {
      this.form.userId = this.$route.query.userId;
    },
    methods: {
      getGroupList(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/accountgroup/list';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.groups){
                // 获取设备数据
                this.groups = obj.data.groups;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      groupChange(val){
        this.form.groupCode = val;
      },
      getAccountDetail(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/account/detail';
        const data = {
          "id":this.form.userId
        };

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.form.group = obj.data.groupName;
              this.form.groupCode = obj.data.groupCode;
              this.form.username = obj.data.username;
              this.form.nickname = obj.data.nickname;
              this.form.phone = obj.data.phone;
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
         if(!err.response){
           this.$message.error(err.message);
         }else{
           this.$message.error(err.response.data.message);
         }
        })
      },
      // groupChange(val){
      //   this.form.groupCode = val;
      // },
      showGroups(){
        this.showMoreGroups = true
      },
      chooseOneGroup(row){
        this.form.groupCode = row.code;
        this.form.group = row.name;
        this.showMoreGroups = false
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //提示更改账号名之后，用户权限会发生改变
            this.$confirm('此操作将改变账号权限，是否继续？','提示',{
              confirmButtonText:'确定',
              cancelButtonText:'取消',
              type:'warning'
            }).then(() => {
              this.editAccount()
            }).catch(() => {
              this.$message({
                type:'info',
                message:'取消修改'
              })
            })
          } else {
            return false;
          }
        });
      },
      editAccount(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/account/update';

        const data = {
            "userId":this.form.userId,
            "groupCode": this.form.groupCode,
            // "username": this.form.username,
            "password": this.form.password,
            "phone": this.form.phone,
            "nickname":this.form.nickname,
        }
        // alert(JSON.stringify(data))

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                message:'修改成功',
                type:'success'
              })
              this.goBack()
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      resetForm(type) {
        if(type=="nickname"){
          this.form.nickname = ''
        }else if(type=="phone"){
          this.form.phone = ''
        }
      },
      goBack(){
        this.$router.back()
      }
    },
  }
</script>


<style lang="scss" scoped>
  .container {
    height: 100%;
    margin-top: $header-height;

    .bread >>>.el-breadcrumb__inner{
      color: #606266;
      font-weight: 400;
    }

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{

        font-size: 20px;

        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }
    }


    .equip-add{

      .add-form{
        padding: 25px 5px 25px 0px;

        .btn{
          width: 240px;
          background-color: RGBA(17, 58, 113, 0.5);
          border: 2px solid #1D4BB6;
          border-radius: 6px;
          box-shadow: 2px 2px 0 0 rgba(0,0,0,0.2);
          caret-color: rgba(0,255,255,0.8);
          color: #FFFFFF;
          font-size: 15px;
          font-weight: 400;
          text-align: left;
        }
      }

      .content-add-user{
        float: left;
        border-radius: 3px;
      }
      .action-button{
          width: 120px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
      }

      .warning-handle{
        float: left;
        background-color: #B26100;
        border: 1px solid rgba(255, 132, 0, 0.84);
        // border-radius: 20px;
        color: #fff;
        margin-left: 5px;
        margin-top: 5px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/view/manage/user/user-edit.vue